export function addBoundaryLayers(map, tileHost) {
    for (const stage of window.app.stages) {
        for (const year of window.app.boundarySetYears) {
            const id = `catchments-${year}-${stage}`;
            const hue = window.app.hues[year];
            const saturation = year === 'primary' ? '50%' : '70%';
            window.map.U.addVector(id, `${tileHost}/tiles/${id}/index.json`)
                .addLine(`${id}-line`, {
                    sourceLayer: 'catchments',
                    lineWidth: {
                        stops: [
                            [7, 1.5],
                            [12, 3],
                        ],
                    },
                    lineColor: `hsl(${hue}, ${saturation}, 50%)`,
                    lineOpacity: 0.6,
                    visibility: 'none',
                    lineJoin: 'round',
                })
                .addLine(`${id}-selected`, {
                    sourceLayer: 'catchments',
                    lineWidth: {
                        stops: [
                            [7, 4.5],
                            [12, 7],
                        ],
                    },
                    lineColor: `hsl(${hue}, 90%, 40%)`,
                    lineBlur: 1,
                    lineOpacity: 0.8,
                    filter: false,
                    visibility: 'none',
                    lineJoin: 'round',
                })
                .addFill(`${id}-selected-fill`, {
                    sourceLayer: 'catchments',
                    fillColor: `hsl(${hue}, 90%, 40%)`,
                    fillOpacity: {
                        stops: [
                            [13, 0.3],
                            [14, 0.1],
                            [16, 0],
                        ],
                    },
                    filter: false,
                    visibility: 'none',
                });
            // .addFill(`${id}-fill`, {
            //     sourceLayer: 'catchments',
            //     fillColor: 'transparent',
            //     visibility: 'none',
            // });
        }
    }
}

export function switchBoundarySet(map, newBoundarySet, oldBoundarySet) {
    // const types = ['line', 'selected', 'selected-fill' /*, 'fill'*/];
    // const hide = () => {
    //     console.log('hide', oldBoundarySet, newBoundarySet);
    //     if (window.app.Map.boundarySet === newBoundarySet) {
    //         // map.U.hide(new RegExp(`catchments-${oldBoundarySet}`));
    //     } else {
    //         // they switched the boundary set very fast
    //     }
    // };
    // if (oldBoundarySet) {
    //     map.once('idle', hide);
    //     window.setTimeout(hide, 200); // failsafe
    // }
    // if (newBoundarySet) {
    //     map.U.show(types.map((type) => `catchments-${newBoundarySet}-${type}`));
    // }
}

export function highlightBoundariesForSchools(map, filter, schools) {
    const bs = window.app.BoundarySelector.boundarySet;
    if (!bs) {
        return;
    }

    let activeBoundarySets = [bs];
    const hasQuery = !schools.every((s) => !s.properties.queryMatch);

    // There can be more than one boundary to display, so we have activate the right boundary sets
    // for the schools that need to be displayed

    if (hasQuery) {
        activeBoundarySets = schools.map(
            (s) => `${s.properties.queryYear}-${s.properties.queryStage}`
        );
    }
    for (const stage of window.app.stages) {
        for (const year of window.app.boundarySetYears) {
            const active = activeBoundarySets.includes(`${year}-${stage}`);
            map.U.setFilter(
                [
                    `catchments-${year}-${stage}-selected`,
                    `catchments-${year}-${stage}-selected-fill`,
                ],
                active && filter
            );
            map.U.toggle(new RegExp(`catchments-${year}-${stage}`), active);
        }
    }
}
